import * as Types from '../../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialAssetGridOutputFragment = { __typename: 'MaterialOutput', id: string, type: Types.MaterialOutputType, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, config?: { __typename: 'JsonFile', id: string, content: any } | null, materialRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, result?: { __typename: 'DataObject', id: string, downloadUrl: string, mediaType?: string | null, originalFileName: string, preview?: { __typename: 'DataObject', downloadUrl: string } | null, jpeg?: { __typename: 'DataObject', downloadUrl: string } | null, tiff?: { __typename: 'DataObject', downloadUrl: string } | null } | null };

export type MaterialAssetGridDataFragment = { __typename: 'Material', id: string, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, organization?: { __typename: 'Organization', id: string } | null, textureGroup?: { __typename: 'TextureGroup', id: string, textureSets: Array<{ __typename: 'TextureSet', id: string, textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string, width: number, height: number }> }> } | null, pinnedImage?: { __typename: 'DataObject', id: string, legacyId: number, downloadUrl: string, mediaType?: string | null, originalFileName: string } | null, outputs: Array<{ __typename: 'MaterialOutput', id: string, type: Types.MaterialOutputType, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, config?: { __typename: 'JsonFile', id: string, content: any } | null, materialRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, result?: { __typename: 'DataObject', id: string, downloadUrl: string, mediaType?: string | null, originalFileName: string, preview?: { __typename: 'DataObject', downloadUrl: string } | null, jpeg?: { __typename: 'DataObject', downloadUrl: string } | null, tiff?: { __typename: 'DataObject', downloadUrl: string } | null } | null }> };

export type MaterialAssetGridDataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialAssetGridDataQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, organization?: { __typename: 'Organization', id: string } | null, textureGroup?: { __typename: 'TextureGroup', id: string, textureSets: Array<{ __typename: 'TextureSet', id: string, textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string, width: number, height: number }> }> } | null, pinnedImage?: { __typename: 'DataObject', id: string, legacyId: number, downloadUrl: string, mediaType?: string | null, originalFileName: string } | null, outputs: Array<{ __typename: 'MaterialOutput', id: string, type: Types.MaterialOutputType, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, config?: { __typename: 'JsonFile', id: string, content: any } | null, materialRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, result?: { __typename: 'DataObject', id: string, downloadUrl: string, mediaType?: string | null, originalFileName: string, preview?: { __typename: 'DataObject', downloadUrl: string } | null, jpeg?: { __typename: 'DataObject', downloadUrl: string } | null, tiff?: { __typename: 'DataObject', downloadUrl: string } | null } | null }> } };

export type MaterialAssetGridJobStateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialAssetGridJobStateQuery = { __typename: 'Query', job: { __typename: 'Job', id: string, state: Types.JobState } };

export type MaterialAssetGridUnpinMutationVariables = Types.Exact<{
  input: Types.MutationUnpinMaterialImageInput;
}>;


export type MaterialAssetGridUnpinMutation = { __typename: 'Mutation', unpinMaterialImage: boolean };

export const MaterialAssetGridOutputFragmentDoc = gql`
    fragment MaterialAssetGridOutput on MaterialOutput {
  id
  type
  job {
    id
    state
  }
  config {
    id
    content
  }
  materialRevision {
    id
    number
  }
  result {
    id
    downloadUrl
    mediaType
    originalFileName
    preview: thumbnail(fileType: jpg, resolution: Medium) {
      downloadUrl
    }
    jpeg: thumbnail(fileType: jpg, resolution: High) {
      downloadUrl
    }
    tiff: thumbnail(fileType: tiff, resolution: High) {
      downloadUrl
    }
  }
}
    `;
export const MaterialAssetGridDataFragmentDoc = gql`
    fragment MaterialAssetGridData on Material {
  id
  __typename
  latestCyclesRevision {
    id
    number
  }
  organization {
    id
  }
  textureGroup {
    id
    textureSets {
      id
      textureSetRevisions {
        id
        width
        height
      }
    }
  }
  pinnedImage {
    id
    legacyId
    downloadUrl
    mediaType
    originalFileName
  }
  outputs {
    ...MaterialAssetGridOutput
  }
}
    `;
export const MaterialAssetGridDataDocument = gql`
    query materialAssetGridData($id: ID!) {
  material(id: $id) {
    ...MaterialAssetGridData
  }
}
    ${MaterialAssetGridDataFragmentDoc}
${MaterialAssetGridOutputFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetGridDataGQL extends Apollo.Query<MaterialAssetGridDataQuery, MaterialAssetGridDataQueryVariables> {
    override document = MaterialAssetGridDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialAssetGridJobStateDocument = gql`
    query materialAssetGridJobState($id: ID!) {
  job(id: $id) {
    id
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetGridJobStateGQL extends Apollo.Query<MaterialAssetGridJobStateQuery, MaterialAssetGridJobStateQueryVariables> {
    override document = MaterialAssetGridJobStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialAssetGridUnpinDocument = gql`
    mutation materialAssetGridUnpin($input: MutationUnpinMaterialImageInput!) {
  unpinMaterialImage(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetGridUnpinGQL extends Apollo.Mutation<MaterialAssetGridUnpinMutation, MaterialAssetGridUnpinMutationVariables> {
    override document = MaterialAssetGridUnpinDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }